import React from 'react';
import { AvatarImage, BrokerWrapper, FaceWrapper } from './style';
import Face from '@lendi-ui/icon/Face';
export var BrokerAvatar = function (_a) {
    var profilePictureURL = _a.profilePictureURL, isFooter = _a.isFooter;
    return (React.createElement(BrokerWrapper, { isFooter: isFooter }, profilePictureURL ? React.createElement(AvatarImage, { src: profilePictureURL }) : React.createElement(FaceAvatar, { isFooter: isFooter })));
};
var FaceAvatar = function (_a) {
    var isFooter = _a.isFooter;
    return (React.createElement(FaceWrapper, { isFooter: isFooter },
        React.createElement(Face, { height: isFooter ? '14px' : '16px', width: isFooter ? '14px' : '16px' })));
};
//# sourceMappingURL=index.js.map